import _some from 'lodash/some';
import makeXslx from './makeXSLX';

export function reorderSeats(fullSet, targetIndex, moveSet) {
  if (moveSet.length === 0) return fullSet; // escape recursion, return final set of changed seats
  let newMoveSet = [];
  const offset = targetIndex + moveSet.length;
  const newIndex = offset >= fullSet.length ? offset - fullSet.length : offset;
  // 1. check to clear seats of selectedGuests
  const newSet = (!_some(moveSet, element => element.seatUUID !== null))
    ? fullSet
    : fullSet.map((seat) => {
      const isClearedSeat = _some(moveSet, elem => elem.seatUUID === seat.uuid);
      if (!isClearedSeat) return seat;
      return { ...seat, guest_id: null, couple_role: null, display_name: null, isEmpty: true };
    });
  // 2. save displaced guests and seat selectedGuests
  for (let i = 0; i < moveSet.length; i += 1) {
    const moveOffset = targetIndex + i;
    const idx = (moveOffset >= fullSet.length) ? moveOffset - fullSet.length : moveOffset;
    const seat = newSet[idx];
    const { key, displayName } = moveSet[i];
    if (!seat.isEmpty) {
      newMoveSet = [...newMoveSet, {
        displayName: seat.display_name,
        key: (seat.guest_id !== null) ? seat.guest_id : seat.couple_role,
        seatUUID: null // any seatUUID will be cleared above at step 1
      }];
    }
    newSet[idx] = {
      ...seat,
      display_name: displayName,
      isEmpty: false,
      guest_id: (typeof key === 'number') ? key : null,
      couple_role: (typeof key === 'string') ? key : null,
    };
  }
  // 👇 recursion call
  return reorderSeats(newSet, newIndex, newMoveSet);
}

export const getMatchedSegments = (name, token) => {
  const tokenStart = name.toLowerCase().indexOf(token);
  const tokenEnd = tokenStart !== -1 ? tokenStart + token.length : 0;
  const start = name.substring(0, tokenStart);
  const match = name.substring(tokenStart, tokenEnd);
  const end = name.substring(tokenEnd);
  return { start, match, end };
};

export const getDisplayName = (guest, isCouple) => {
  if (isCouple) {
    return { firstPart: guest.first_name, secondPart: guest.last_name };
  }
  const guestInfo = guest.guest_view;
  // if no first name we assume 'Child of'/'Guest of' and separate from display_name:
  const isTertiary = guestInfo.first_name === null;
  const firstPart = isTertiary ? guest.display_name.substring(0, 8) : guestInfo.first_name;
  const secondPart = isTertiary ? guest.display_name.substring(9) : guestInfo.family_name;
  return { firstPart, secondPart };
};

export const makeChartList = (
  guestsByID, mealsByID, orderedTableUUIDs, seatsByUUID, tablesByUUID
) => {
  const allSeats = orderedTableUUIDs
    // flatten into seats
    .reduce((acc, uuid) => [...acc, ...tablesByUUID[uuid].seats], []);
    // eliminate empty seats
  const filledSeats =
    allSeats.filter(seatUUID => {
      return seatsByUUID[seatUUID].display_name !== null;
    })
  // convert to seats to guest w/ listing data
  const list = filledSeats
    .map(seatUUID => {
      const seat = seatsByUUID[seatUUID];
      const name = seat.display_name;
      const guestID = seat.guest_id;
      const tableName = tablesByUUID[seat.table_uuid].name;
      const mealName = (guestID !== null)
        ? mealsByID[guestsByID[guestID].mealOptionID]
        : null;
      return { name, tableName, mealName };
    })
  return list;
};

const formatXLSX = (data) => { 
  const headerRow = [[
    { value: 'Name', type: 'string' },
    { value: 'Table', type: 'string' },
    { value: 'Meal', type: 'string' }
  ]];
  const dataRows = data.map(  
    set => (set.mealName === null) || (set.mealName === undefined)
      ? [
        { value: set.name, type: 'string' },
        { value: set.tableName, type: 'string' },
      ]
      : [
        { value: set.name, type: 'string' },
        { value: set.tableName, type: 'string' },
        { value: set.mealName, type: 'string'},
      ]
  );
  return headerRow.concat(dataRows);
};

export const downloadXLSX = (filename, data) => (
  // console.log(filename, formatXLSX(data))
  makeXslx({ filename, sheet: { data: formatXLSX(data) } })
);


const splitTableData = (tableFields, tableCount) => {
  const { num_tables: numTables, num_seats: numSeats } = tableFields;
  const tableSet = [];
  for (let i = 0; i < numTables; i += 1) {
    const displayCount = tableCount + 1 + i;
    tableSet.push(
      { name: `Table ${displayCount}`, num_seats: numSeats, shape: 1, display_order: displayCount }
    );
  }
  return tableSet;
};

export const formatTableRequest = (tableSets) => tableSets.length > 0 ?
  tableSets.reduce((acc, set) => {
    const { new_tables: newTables, num_tables: numTables } = acc;
    return {
      new_tables: newTables.concat(splitTableData(set, numTables)),
      num_tables: numTables + set.num_tables
    };
  }, { new_tables: [], num_tables: 0 })
  :
  { new_tables: [], num_tables: 0 };



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/util/seatingChartUtils.js